import { Component, OnInit, Input, OnChanges, Output, EventEmitter, HostBinding } from '@angular/core';
import { Execution, SubTool, SubToolInfo } from 'src/app/models';
import { Router } from '@angular/router';
import { ExecutionService, ExecutionSidebarService, ToastService } from 'src/app/services';
import { ToolType } from 'src/app/resources/tool-utils';

@Component({
    selector: 'app-execution-sidebar',
    templateUrl: './execution-sidebar.component.html',
    styleUrls: ['./execution-sidebar.component.scss'],
    standalone: false
})
export class ExecutionSidebarComponent implements OnInit, OnChanges {
  @Input() execution: Execution;

  continueStates : string[];setIsDescriptionPresent
  @Input('statesInWhichContinueIsAvailable') set setContinueStates(value : string[] | null){
    this.continueStates = value && value.length > 0 ? value : ['Completed']
  }

  isDescriptionPresent: boolean;
  @Input('isDescriptionPresent') set (attribute: boolean | '') {
    this.isDescriptionPresent = attribute === '' || attribute;
  }

  isContinueAvailable: boolean;
  @Input('isContinueAvailable') set setIsContinueAvailable(attribute: boolean | '') {
    this.isContinueAvailable = attribute === '' || attribute;
  }

  @Input() subTools: SubTool[];


  @Output() continue = new EventEmitter<boolean>();
  btnText: string;
  subToolsAvailable: SubToolInfo[] = [];
  @HostBinding('class.container-sidebar') containerSidebar = true;
  loading: boolean = false;

  constructor(
    private executionSidebarService: ExecutionSidebarService,
    private executionService : ExecutionService,
    private router: Router,
    private toastService: ToastService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.subTools) {
      this.isExecuteDisabled();
    }
    if (!this.execution) { return; }
    switch (this.execution.status) {
      // Todo far aggiungere lo status nella get exec info e cambiare
      case 'Draft':
        this.btnText = 'Execute';
        break;
      case 'Completed':
        this.btnText = 'Continue';
        break;
      default:
        this.btnText = 'Execute';
        break;
    }
  }

  /**
   * Active flags that tell you which files are missing to load in order to execute
   */

  isExecuteDisabled() {
    // console.log('is-execute-disabled')
    // One level of subtool
    if (this.subTools.length === 1) {
      this.subToolsAvailable = this.subTools[0].subtool_list.filter(subTool => subTool.subtool_available);
    } else {
      // More levels of subtool
      if (this.subTools[0].subtool_list[0].subtool_available) {
        this.subToolsAvailable = this.subTools[1].subtool_list.filter(subTool => subTool.subtool_available);
      }
    }
  }

  /**
   * Launches execution when the button is enabled
   */
  async launchExecution() {
      const response = (await this.executionSidebarService.launchExecution(this.execution.id));
      if(this.execution.name_tool.toUpperCase() == ToolType.NEWRO){
        
        const MAX_POLL_ATTEMPTS = 20; // 20 × 3 s = 60 s max
        for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
          await this.delay(3000);
          const execution: Execution = await this.executionService.getToolInfo(this.execution.id);
          this.execution = execution;
          if (execution.status === 'Completed') {
            break;
          }
          if (execution.status === 'Error' || execution.status === 'Failed') {
            throw new Error(`Execution ended with status: ${execution.status}`);
          }
          if (attempt === MAX_POLL_ATTEMPTS - 1) {
            throw new Error('Execution timed out after maximum polling attempts');
          }
        }
        





      }

      //console.log("hello")
      if (response.status) {
        //this.router.navigate([`execution/${this.execution.id}/redirect`], { queryParams: { status: 'Completed' } });
        if(this.execution.name_tool.toUpperCase() === ToolType.RO){
          this.loading = false;
          this.router.navigate([`/tool/ro-pbi-wrapper`, {idExecution: this.execution.id, executionName: this.execution.name, executionStatus: 'Completed', isPrevComponentHome: 'true'}]);
        } else if(this.execution.name_tool.toUpperCase() === ToolType.NEWRO){
          this.loading = false;
          this.router.navigate([`/tool/ttd-pbi/${this.execution.id}`, {executionName: this.execution.name, executionStatus: 'Completed', isPrevComponentHome: 'true'}]);
        }
         else if (this.execution.name_tool.toUpperCase() === ToolType.ST){
          this.loading = false;
          this.router.navigate([`/tool/${ToolType.ST}/${this.execution.id}`]);
        } else if (this.execution.name_tool.toUpperCase() === ToolType.SFCR){
          this.loading = false;
          this.router.navigate([`/tool/${ToolType.SFCR}/${this.execution.id}`]);
        }
        else{
          this.router.navigate([`execution/${this.execution.id}/redirect`], { queryParams: { status: 'Completed' } });
        }
      }
    }

  continueAgg() {
    this.continue.emit(true);
  }

  /**
   * Manages the continue button in the two cases of use of the sidebar: after loading the files in the input pages (Draft)
   * or for extra configurations such as NLL or IFRS17 Non life (Completed)
   */
  async handleSubmit(){
    this.loading = true;  
    try{
      await this._handleSubmit();
    }catch(e){
      // console.log(e);
      this.toastService.showError({
        message : e.message
      });
    }
    finally{
      this.loading = false;
    }
  }


  async _handleSubmit() {
    // console.log(this.execution)
    if (!this.execution) { return; }

    if(this.execution.status === 'Draft'){
      if (this.subToolsAvailable?.length) {
        await this.launchExecution();
      }
    }
    if(this.isContinueAvailable && this.continueStates.includes(this.execution.status)){
      await this.continueAgg();
    }
  }

  /**
   * Manages when the continue button should be disabled
   */

  handleDisabledButton() {
    if (!this.execution) { return; }
    if(this.loading){
      return true;
    }
    if(this.execution.status == 'Draft'){
      return !this.subToolsAvailable?.length;
    }
    if(this.continueStates.includes(this.execution.status)){
      return !this.isContinueAvailable;
    }
    return false;
  }


  private delay(milliseconds : number) : Promise<void>{
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
    });
}
}
